var _mask, _g, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0597 24.0003H0V3.05273L21.0597 3.05273V24.0003Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.054 10.3187V21.0077C19.054 21.5587 18.605 22.0057 18.052 22.0057H3.009C2.455 22.0057 2.006 21.5587 2.006 21.0077V6.04573C2.006 5.49573 2.455 5.04773 3.009 5.04773H13.471L15.492 3.05273H3.009C1.35 3.05273 0 4.39473 0 6.04573V21.0077C0 22.6587 1.35 24.0007 3.009 24.0007H18.052C19.71 24.0007 21.06 22.6587 21.06 21.0077V8.33873L19.054 10.3187Z",
    fill: "#9699B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22505 12.5993L8.45605 15.4623L11.3581 14.7093L22.2991 3.80634L20.1671 1.69434L9.22505 12.5993Z",
    fill: "#9699B5"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 4,
    height: 4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 3.10573V0.000976563L20.8799 0.000976562V3.10573H24Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7109 2.39973C24.0979 2.01473 24.0969 1.38573 23.7079 1.00373L22.9839 0.287731C22.5959 -0.0962691 21.9619 -0.0942691 21.5749 0.291731L21.5729 0.293731C21.1879 0.678731 20.8799 0.993731 20.8799 0.993731L23.0139 3.10573C23.0139 3.10573 23.3209 2.79073 23.7069 2.40373L23.7109 2.39973Z",
    fill: "#9699B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMobile);
export default __webpack_public_path__ + "static/media/edit_mobile.b870d375.svg";
export { ForwardRef as ReactComponent };